import { StylesConfig } from 'react-select';

import { ResolvedTheme } from '@contexts/ThemeModeContext';

const getReactSelectStyles = (resolvedTheme: ResolvedTheme): StylesConfig<any, boolean> => {
  const isDark = resolvedTheme === 'dark';

  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: isDark ? '#111827' : base.backgroundColor,
      borderColor: isDark ? '#4b5563' : base.borderColor,
      boxShadow: state.isFocused ? `0 0 0 1px ${isDark ? '#60a5fa' : '#2684ff'}` : base.boxShadow,
      '&:hover': {
        borderColor: isDark ? '#6b7280' : base.borderColor,
      },
    }),
    input: (base) => ({
      ...base,
      color: isDark ? '#e5e7eb' : base.color,
    }),
    singleValue: (base) => ({
      ...base,
      color: isDark ? '#e5e7eb' : '#111827',
    }),
    placeholder: (base) => ({
      ...base,
      color: isDark ? '#9ca3af' : '#6b7280',
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: isDark ? '#111827' : '#ffffff',
      color: isDark ? '#e5e7eb' : '#111827',
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: isDark ? '#111827' : '#ffffff',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? isDark
          ? '#374151'
          : '#e5e7eb'
        : state.isFocused
        ? isDark
          ? '#1f2937'
          : '#f3f4f6'
        : isDark
        ? '#111827'
        : '#ffffff',
      color: isDark ? '#e5e7eb' : '#111827',
      cursor: 'pointer',
      ':active': {
        backgroundColor: isDark ? '#4b5563' : '#d1d5db',
      },
    }),
    noOptionsMessage: (base) => ({
      ...base,
      color: isDark ? '#9ca3af' : '#6b7280',
    }),
    loadingMessage: (base) => ({
      ...base,
      color: isDark ? '#9ca3af' : '#6b7280',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: isDark ? '#9ca3af' : base.color,
      '&:hover': {
        color: isDark ? '#d1d5db' : base.color,
      },
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: isDark ? '#4b5563' : base.backgroundColor,
    }),
  };
};

export default getReactSelectStyles;
